import React, { useEffect } from 'react'
import { Navigate, Route, Routes, useLocation } from 'react-router-dom'
import './App.css'
import { HomePage } from './pages/home'
import './i18n'
import CookieBanner from './components/CookieBanner'
import { SpecialOffer } from './pages/specialoffer'
import Registration from './pages/specialoffer/registration'
import { ActivatePage } from './pages/activate'
import RegistrationActivate from './pages/activate/registration'
import { HomeASBOPage } from './pages/home-asbo'
import RegistrationActivateAsbo from './pages/activate/registration-asbo'
import { HomeCSDSIPPage } from './pages/home-csdsip'
import { HomeLloydsPage } from './pages/home-lloyds'
import { HomeHSBCPage } from './pages/home-hsbc'
import { EducationmutualPage } from './pages/home-educationmutual'
import RegistrationActivateEducationmutual from './pages/home-educationmutual/registration'

function ScrollToTop() {
  const { pathname } = useLocation()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])

  return null
}

function App() {
  return (
    <div className='App'>
      <ScrollToTop />
      <Routes>
        <Route index element={<HomePage />} />
        <Route path='/hsbc' element={<HomeHSBCPage />} />
        <Route path='/educationmutual' element={<EducationmutualPage />} />
        <Route path='/csdsip' element={<HomeCSDSIPPage />} />
        <Route path='/asbo' element={<HomeASBOPage />} />
        <Route path='/lloyds' element={<HomeLloydsPage />} />
        <Route path='/asbo/book-a-demo' element={<RegistrationActivateAsbo />} />
        <Route path='/online/uk/' element={<SpecialOffer />} />
        <Route path='/online/us/' element={<SpecialOffer loc={'us'} />} />
        <Route path='/online/eu/' element={<SpecialOffer loc={'eu'} />} />
        <Route path='/online/aus/' element={<SpecialOffer loc={'aus'} />} />
        <Route path='/online/uk/registration' element={<Registration />} />
        <Route path='/online/us/registration' element={<Registration loc={'us'} />} />
        <Route path='/online/eu/registration' element={<Registration loc={'eu'} />} />
        <Route path='/online/aus/registration' element={<Registration loc={'aus'} />} />
        <Route path='/activate/uk' element={<ActivatePage />} />
        <Route path='/activate/hsbc' element={<ActivatePage ishsbc />} />
        <Route path='/activate/eu' element={<ActivatePage loc={'eu'} />} />
        <Route path='/activate/us' element={<ActivatePage loc={'us'} />} />
        <Route path='/activate/se' element={<ActivatePage loc={'se'} />} />
        <Route path='/activate/ch' element={<ActivatePage loc={'ch'} />} />
        <Route path='/activate/in' element={<ActivatePage loc={'in'} />} />
        <Route path='/activate/registration' element={<RegistrationActivate />} />
        <Route path='/educationmutual/activate/registration' element={<RegistrationActivateEducationmutual />} />
        <Route path='*' element={<Navigate to='/' replace />} />
      </Routes>

      <CookieBanner />
    </div>
  )
}

export default App
